<template>
  <el-button type="primary" icon="el-icon-setting" @click="open" :size="size">
    <el-dialog :title="nodeVersion.name" :visible.sync="modal" append-to-body>
      <el-tabs v-model="tab" tab-position="right" >
        <el-tab-pane label="Détail" name="info" >
          <div>
            Nom: {{ nodeVersion.name }}
          </div>
        </el-tab-pane>
        <el-tab-pane label="Modifier" name="edit" >
          <node-version-form
             v-model="nodeVersion"
             :dir="dir"
             @cancel="cancel"
             @input="updated" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </el-button>
</template>

<script>
import {NodeVersion} from '../entity'
import NodeVersionForm from './NodeVersionForm'

export default {
  props: {
    node: {
      type: NodeVersion,
      required: true
    },
    dir: {
      type: NodeVersion,
      default: null
    },
    size: {
      type: String,
      default: 'default'
    }

  },
  data () {
    return {
      nodeVersion: this.node.clone(),
      modal: false,
      tab: 'info'
    }
  },
  watch: {
    node () {
      this.nodeVersion = this.node.clone()
    }
  },
  methods: {
    open () {
      this.tab = 'info'
      this.modal = true
    },
    cancel () {
      this.nodeVersion = this.node.clone()
      this.modal = false
    },
    updated () {
      this.$emit('edit')
      this.modal = false
    }
  },
  components: {
    NodeVersionForm
  }
}
</script>



// WEBPACK FOOTER //
// src/files/components/NodeDetail.vue